import React, { Component } from 'react'
import style from '../style.module.less'
import { Input, Button, Spin, Card, MagicInput } from 'hljd'
import { observer, inject } from 'mobx-react'
import ServiceFee from './ServiceFee'
import FormItem from './FormItem'
import Menus from './Menus'
import MenuPhotoItem from './MenuPhotoItem'

@inject('store')
@observer
export default class extends Component {
  onCliped = value => {
    const {
      clipUrl
      // pixel: { height, width }
    } = value
    const { store } = this.props
    const { setFromValue } = store

    setFromValue('cover_path')(clipUrl)
  }

  onDel = () => {
    const { store } = this.props
    const { setFromValue } = store

    setFromValue('cover_path')('')
  }

  render() {
    const { store } = this.props
    let {
      getMenuLoading,
      saveMenuLoading,
      menuName,
      tablePrice,
      addition,
      setFromValue,
      submit,
      menuStore,
      menuPics,
      recommend_food,
      business_status
    } = store
    menuName = menuName ? menuName : ''
    addition = addition ? addition : ''
    /*  const uploadDesc = (
      <div className="uploadDesc">
        <div>添加封面</div>
        <div>312 * 202</div>
      </div>
    )*/

    return (
      <Spin
        className={style.content}
        spinning={getMenuLoading || saveMenuLoading}
      >
        <Card title="基本信息" bordered={false}>
          <div className={style.form}>
            <FormItem label="菜单名称" required>
              <MagicInput
                style={{ width: 440 }}
                maxLength={5}
                showCount
                countPosition="inner"
                value={menuName}
                onChange={setFromValue('menuName')}
                placeholder="请输入菜单名称，最多5个字"
              />
              <span className={style.desc} />
            </FormItem>
            <FormItem label="单桌价位" required>
              <Input
                style={{ width: 200 }}
                value={tablePrice}
                placeholder="请输入单桌价位"
                onChange={setFromValue('tablePrice')}
              />
              <span style={{ color: '#333333', marginLeft: 12 }}>元/桌</span>
            </FormItem>
            <FormItem label="菜单服务费" required flexStart>
              <ServiceFee />
            </FormItem>
            <FormItem label="推荐菜" required>
              <MagicInput
                maxLength={15}
                showCount
                countPosition={'inner'}
                value={recommend_food}
                placeholder="请输入该菜单的推荐菜，最多15字"
                onChange={setFromValue('recommend_food')}
                style={{ width: 440 }}
              />
            </FormItem>
            <FormItem label="附加信息" flexStart>
              <MagicInput.TextArea
                placeholder="菜单如有特殊要求，请输入补充"
                style={{ width: 440 }}
                rows={4}
                value={addition}
                maxLength={150}
                showCount
                countPosition="inner"
                onChange={setFromValue('addition')}
              />
            </FormItem>
            {/* <FormItem label="菜单封面" flexStart required>
              <p style={{ color: '#666', marginBottom: 8 }}>
                展示在酒店主页菜单列表，最大不超过10M。
              </p>
              <Upload
                // onOk={this.onOk}
                onError={this.onError}
                onDelete={this.onDel}
                showDelete
                link={cover_path}
                max_file_size="10mb"
                clipabled
                aspect={316 / 202}
                onCliped={this.onCliped}
                filters={{
                  mime_types: [
                    {
                      title: 'Image files',
                      extensions: 'jpg,png,jpeg,bmp'
                    }
                  ]
                }}
                description={uploadDesc}
              />
            </FormItem>*/}
            {business_status && (
              <FormItem label="菜品图片" required flexStart>
                <MenuPhotoItem
                  value={menuPics}
                  onChange={setFromValue('menuPics')}
                />
              </FormItem>
            )}
          </div>
        </Card>
        <Card title="菜单详情" bordered={false} style={{ marginBottom: 88 }}>
          <div className={style.form}>
            <Menus store={menuStore} />
          </div>
        </Card>
        <div className={style.footer}>
          <Button
            className={style.submit}
            onClick={submit}
            type="primary"
            loading={saveMenuLoading}
          >
            提交审核
          </Button>
        </div>
      </Spin>
    )
  }
}
